import { jsx } from 'react/jsx-runtime';
import { Size5, IconIconOnLight } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import React__default, { forwardRef } from 'react';
import styles from './toolbar.module.js';
var ToolbarIcon = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var icon = props.icon,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? IconIconOnLight : _props$color;
  return jsx("span", {
    ref: forwardedRef,
    className: clsx(styles.toolbarIcon, className),
    children: /*#__PURE__*/React__default.createElement(icon, {
      width: Size5,
      height: Size5,
      role: 'presentation',
      color: color
    })
  });
});
export { ToolbarIcon };